import React, { useState } from 'react';

function NoticeBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
      borderBottom: '1px solid #f59e0b',
      padding: '0.875rem 2rem',
    }}>
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.875rem',
      }}>
        <div style={{
          flexShrink: 0,
          width: 24,
          height: 24,
          background: '#f59e0b',
          color: 'white',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: '0.875rem',
          marginTop: '0.125rem',
        }}>!</div>
        <div style={{
          flex: 1,
          fontSize: '0.875rem',
          color: '#92400e',
          lineHeight: 1.5,
        }}>
          <strong style={{ color: '#78350f' }}>Service Update</strong>
          <p style={{ margin: '0.125rem 0 0' }}>
            Virtual Zebra Printer will transition to a paid service on <strong>31 July 2026</strong>.
            To discuss licensing options, please contact{' '}
            <a href="mailto:sales@matt-tye.com" style={{
              color: '#78350f',
              fontWeight: 600,
              textDecoration: 'underline',
            }}>sales@matt-tye.com</a>.
          </p>
        </div>
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss notice"
          style={{
            flexShrink: 0,
            background: 'none',
            border: 'none',
            color: '#92400e',
            fontSize: '1.25rem',
            cursor: 'pointer',
            padding: '0 0.25rem',
            lineHeight: 1,
            opacity: 0.6,
          }}
        >&times;</button>
      </div>
    </div>
  );
}

export default NoticeBanner;
